import toast from 'react-hot-toast';

import { useSearchParams } from '@remix-run/react';

import useEmail from '~/hooks/useEmail';

interface Props {
  fetcher: any;
}

interface ReturnProps {
  handleSubmit: (formData: FormData) => boolean;
}

const useFormSubmit = ({ fetcher }: Props): ReturnProps => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [, setEmail] = useEmail();

  const handleSubmit = (formData: FormData) => {
    const trimmedEmail = (formData.get('email') || '')?.toString().trim();
    formData.set('is_js_enabled', 'true');
    formData.set('email', trimmedEmail);

    // We get a lot of headless bots that submit empty emails. This will remove those from actual submissions and processed sentry errors.
    if (!trimmedEmail) {
      toast.error('Please enter a valid email address');
      return false;
    }

    // Update Email in local storage
    setEmail(trimmedEmail);

    // Update email in search params
    searchParams.set('email', trimmedEmail);
    setSearchParams(searchParams, { replace: true });

    fetcher.submit(formData, {
      method: 'post',
      action: '/recommendations_subscribe_form',
    });

    return true;
  };

  return {
    handleSubmit,
  };
};

export default useFormSubmit;
